<template>
  <div class="delegacion">
    <DocumentosDelegacionTable :params="params" :fieldsI.sync="fields" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { IConfColumnaPais, IField } from "@/entities";
import { Action } from "vuex-class";
import { IColumnaResponse, IDocumentacionParams } from "@/services";
import DocumentosDelegacionTable from "@/components/documentacion/DocumentosDelegacionTable.vue";
import VueMethods from "@/vue-methods";
import { Dictionary } from "vue-router/types/router";

@Component({
  components: {
    DocumentosDelegacionTable,
  },
  mixins: [VueMethods],
})
export class ByDelegationComponent extends Vue {
  @Prop({ required: true }) columnsConfig!: IColumnaResponse;
  @Prop({ required: true }) params!: IDocumentacionParams;

  @Action("fetchColumna") fetchColumna!: (
    codTabla: string
  ) => Promise<IColumnaResponse | undefined>;

  created(): void {
    this.params.size = 1000;
    this.params.orderBy = "id";
    this.params.fechaFin = this.params.fechaInicio;
    this.$router
      .replace({ path: this.$route.path, query: { ...this.params } as Dictionary<any> })
      .catch(() => {
        // Do nothing
      });
  }

  get fields(): IField[] {
    const visibleKeys = this.columnsConfig?.codColumna?.split(",").filter((s) => s !== "") || [];
    const columnas: IField[] = [
      {
        key: "actions-left",
        label: this.$t("label.acciones"),
        sortable: false,
        thClass: "table-header table-header-active text-center",
        tdClass: "table-cell-first text-center",
        visible: true,
        class: "table-cell",
        aux: true,
      },
    ];

    this.columnsConfig?.columnas?.forEach((column: IConfColumnaPais) => {
      columnas.push({
        key: column.keyFront,
        label: this.$t("label." + column.codColumna),
        sortable: true,
        thClass: "table-header",
        tdClass: "table-cell-middle",
        thStyle: column.widthFront ? { width: column.widthFront } : {},
        visible: this.isVisible(visibleKeys, column.codColumna),
        class: "table-cell",
        aux: false,
        code: column.codColumna,
        formatter: (value: any): string => {
          if (column.formatType == "Date") {
            return this.filterDate(value);
          } else if (column.formatType == "Number") {
            return this.filterNumber(value, 2);
          }
          return value;
        },
      });
    });

    columnas.push({
      key: "add-columns",
      label: "",
      sortable: false,
      thClass: "table-header table-header-add-columnas",
      tdClass: "table-cell table-add-columns",
      visible: true,
      aux: true,
    });

    return columnas;
  }

  set fields(fields: IField[]) {
    this.columnsConfig.codColumna =
      fields
        .filter((item) => item.visible && !item.aux)
        .map((item) => item.code)
        .join(",") || "";
  }

  isVisible(visibleKeys: string[], column: string): boolean {
    return !visibleKeys.length || !!visibleKeys.find((key) => key === column);
  }

  action(action: { action: string; data?: any }): void {
    if (action.action === "download") {
      alert("download");
    }
  }
}
export default ByDelegationComponent;
</script>
